export const getTitleContainerStyles = {
	alignItems: 'center',
	justifyContent: 'center',
	paddingX: { xs: '1.25rem', md: '2%', lg: '5%', xl: '6rem' },
	textAlign: 'center',
	textWrap: 'pretty',
	maxWidth: '100%',
	margin: `0 auto`,
	background: '#002044',
};

export const titleStyles = {
	fontSize: { xs: '42px', md: '60px' },
	color: '#FFFFFF',
	paddingTop: { xs: '2.5rem', md: '3.75rem' },
	paddingBottom: { xs: '2.5rem', md: '.75rem' },
};
